var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spinner-wheel-label _container",class:[
    `--${_vm.variant}`,
    {
      '--initial': !_vm.text,
      '--winning': _vm.showWinner,
    },
  ],style:({'background-color': _vm.backgroundColor})},[(!_vm.text)?_c('div',{staticClass:"spinner-wheel-label _prompt"},[_vm._v("\n    "+_vm._s(_vm.$t('pressToSpinTheWheel'))+"\n  ")]):_c('div',{staticClass:"spinner-wheel-label _text"},[_vm._v("\n    "+_vm._s(_vm.text)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }